import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { InvoiceDialogHistoryComponent } from './invoice-dialog/invoice-dialog-history.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  dataSource = new PaymentHistoryDataSource(this.accountService);
  tableFilters = '';
  configData: any = {};
  invoiceStatus: any = [];
  invoiceType: any = [];
  screenHeight;
  screenWidth;
  collapsed;
  invoiceCount: number;
  small_device_display = false;
  displayedColumns =
    ['id', 'name', 'pname', 'invoiceRef', 'invoiceId', 'date', 'periodFrom', 'periodTo', 'dueDate', 'amount', 'status', 'invoice'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  // @ViewChild('go') go: ElementRef;
  id;
  constructor(
    private dialog: MatDialog ,  private router: Router, private commonFilter: CommonfilterService,  private activatedRoute: ActivatedRoute, private route: ActivatedRoute , private commonService: CommonfilterService, private accountService: AccountService
  ) {
    this.commonFilter.getConfigData()
      .subscribe(res => {
        this.configData = res;
        // console.log(this.configData);
        this.invoiceStatus = this.configData.invoiceStatusDetails;
        this.invoiceType = this.configData.invoiceTypeDetails;
      });
      this.onResize();
   }

  ngOnInit() {
    let id;
    this.route.parent.params.subscribe(params => {
      id = params['id'];
      // console.log(id);
      this.id = id;
      // this.accountService.getTestTransactionDetails(id)
      // .subscribe(res => {
      // this.payment_trans_details = res;

      // });

    });
    this.dataSource.loadSalesReps(this.tableFilters, 'false', 0, 100 , this.id);
    this.getTotalCount(this.tableFilters , this.id);
    
}
getTotalCount(filters , accountId) {
  this.accountService.getTotalPaymentHistoryCount(filters , accountId)
    .subscribe(
      res => {
        this.invoiceCount = res;
      });
}
onResize() {
  this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
  // console.log(this.screenWidth);
  if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
    // console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
    // console.log(this.screenWidth);
    this.small_device_display = true;
  } else {
    this.small_device_display = false;
  }
}
// ngAfterViewInit() {
//   this.paginator.page
//   .pipe(
//       tap(() => this.loadSalesRepPage())
//   )
//   .subscribe();

//   fromEvent(this.go.nativeElement, 'click')
//   .pipe(
//       debounceTime(150),
//       distinctUntilChanged(),
//       tap(() => {
//           this.tableFilters = this.commonService.createfilterParams('history');
//           this.getTotalCount(this.tableFilters , this.id);
//           this.paginator.pageIndex = 0;
//           this.loadSalesRepPage();


//       })
//   )
//   .subscribe();
// }
loadSalesRepPage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadSalesReps(

    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize,
    this.id);
}
showInvoiceDetails(uuid) {
  this.router.navigate(['../../../../subscription', 'print'], { queryParams: { invoiceUuid: uuid }, relativeTo: this.activatedRoute });
  // const dialogRef = this.dialog.open(InvoiceDialogHistoryComponent, {
  //   width: '700px',
  //   data: uuid
  // });

  // dialogRef.afterClosed().subscribe(result => {

  //   // this.getInvoices(this.accountId, this.subscriptionStatus);

  // });

}
}
export class PaymentHistoryDataSource implements DataSource<any> {

  constructor(private accountService: AccountService) {

  }
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  private salesRepSubject = new BehaviorSubject<any>([]);

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.salesRepSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.salesRepSubject.complete();
    this.loadingSubject.complete();
  }
  loadSalesReps(filter,
    sortDirection, tcount, pageSize , id) {
    this.loadingSubject.next(true);

    this.accountService.getPaymentHistory(filter, sortDirection,
      tcount, pageSize , id).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(
        salesReps => {
          this.salesRepSubject.next(salesReps);
        }
      );
  }

}
